import { Clock } from "three";
import { EventsCachedMesh } from "./EventsCachedMesh.js";
export class EventsHandler {
    //public enabled: boolean; //TODO USE IT
    _parent; //todo add dispose if delete scene?
    _clock = new Clock();
    constructor(parent) {
        this._parent = parent;
    }
    triggerEvents() {
        this.triggerOnFrameGeneration(this._clock.getDelta());
    }
    triggerOnWindowResize() {
        let meshes = EventsCachedMesh.getRegisteredMesh("onWindowResize", this._parent.id);
        if (meshes) {
            for (let mesh of meshes) {
                mesh.triggerEvent("onWindowResize");
            }
        }
    }
    triggerOnFrameGeneration(delta) {
        let meshes = EventsCachedMesh.getRegisteredMesh("onFrameGeneration", this._parent.id);
        if (meshes) {
            for (let mesh of meshes) {
                mesh.triggerEvent("onFrameGeneration", delta);
            }
        }
    }
    areVec3EqualsWithNullCheck(v1, v2) {
        return v1 && v2 && v1.equals(v2);
    }
    areEulerEqualsWithNullCheck(e1, e2) {
        return e1 && e2 && e1.equals(e2);
    }
}
//# sourceMappingURL=EventsHandler.js.map